import * as MultiGridStyles from '~/components/MultiGrid/styles';
import ClickOutside from '~/components/ClickOutside';
import { useBoolean } from '~/hooks/useBoolean';
import { useCustomPopper } from '~/hooks/popper';
import { SAME_WIDTH_MODIFIER } from '~/constants/popper';
import FilterOptionsDropdown from './FilterOptionsDropdown';

const SAME_WIDTH_POPPER_OPTIONS = Object.freeze({
  strategy: 'fixed',
  placement: 'bottom-start',
  modifiers: [SAME_WIDTH_MODIFIER],
});

interface IHeaderContentProps {
  fieldValue: string;
  fieldLabel: string;
  showFilter: boolean;
  isSortable: boolean;
}

const HeaderContent = ({ fieldValue, fieldLabel, showFilter, isSortable }: IHeaderContentProps) => {
  //   const { handleSort } = useFiltersContext();
  const [areFilterOptionsShown, filterOptionsShownActions] = useBoolean();
  const popperAttributes = useCustomPopper(SAME_WIDTH_POPPER_OPTIONS);

  return (
    <MultiGridStyles.HeaderWrapper
      className="spread full-dimension"
      isActive={areFilterOptionsShown}
      {...popperAttributes.reference}
    >
      {fieldLabel}
      <div>
        {isSortable && (
          <MultiGridStyles.HeaderIconWrapper
            className="cursor-pointer center"
            // onClick={() => handleSort(fieldValue)}
          >
            <span className="bold">^</span>
          </MultiGridStyles.HeaderIconWrapper>
        )}
        {showFilter && (
          <MultiGridStyles.HeaderIconWrapper
            className="cursor-pointer center"
            onClick={filterOptionsShownActions.toggle}
            isActive={areFilterOptionsShown}
          >
            <span className="bold">Filter</span>
            {areFilterOptionsShown && (
              <ClickOutside onClose={filterOptionsShownActions.off}>
                <FilterOptionsDropdown
                  fieldValue={fieldValue}
                  fixedAttributes={popperAttributes.fixed}
                />
              </ClickOutside>
            )}
          </MultiGridStyles.HeaderIconWrapper>
        )}
      </div>
    </MultiGridStyles.HeaderWrapper>
  );
};

export default HeaderContent;
